export const PaymentType = {
  ABord: 0,
  Stripe: 1,
  Facture: 2,
  FactureRetail: 3,
}

export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType]

// Clé de traduction (enums.payment_type.*) associée à chaque mode de paiement,
// pour éviter de dupliquer cette correspondance dans chaque page.
export const PaymentTypeTranslationKey: Record<PaymentType, string> = {
  [PaymentType.ABord]: 'abord',
  [PaymentType.Stripe]: 'stripe',
  [PaymentType.Facture]: 'facture',
  [PaymentType.FactureRetail]: 'facture_retail',
}

export function buildPaymentTypeLabels(
  tEnums: (key: string) => string,
): Record<PaymentType, string> {
  return Object.fromEntries(
    Object.entries(PaymentTypeTranslationKey).map(([type, key]) => [
      type,
      tEnums(`payment_type.${key}`),
    ]),
  ) as Record<PaymentType, string>
}
